import { AxiosResponse } from 'axios';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import {
    getDailyStatisticsByVehicleIdApi,
    getFuelReportByDriverApi,
    getFuelReportByVehicleApi
} from "../../services/statistics.service";
import actions from "./actions"

export function* GET_DAILY_STATISTICS(action: {payload: any, type:string}){
    try {
        const response: AxiosResponse<any> = yield call(
          getDailyStatisticsByVehicleIdApi,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_DAILY_STATISTICS,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export function* GET_FUEL_REPORT_BY_VEHICLE(action: {payload: any, type: string}){
    try {
        const response: AxiosResponse<any> = yield call(
          getFuelReportByVehicleApi,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_FUEL_REPORT_BY_VEHICLE,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export function* GET_FUEL_REPORT_BY_DRIVER(action: {payload: any, type: string}){
    try {
        const response: AxiosResponse<any> = yield call(
          getFuelReportByDriverApi,
          action.payload
        );
        if (response.data) {
            yield put({
                type: actions.SET_FUEL_REPORT_BY_DRIVER,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DAILY_STATISTICS, GET_DAILY_STATISTICS),
        takeEvery(actions.GET_FUEL_REPORT_BY_VEHICLE, GET_FUEL_REPORT_BY_VEHICLE),
        takeEvery(actions.GET_FUEL_REPORT_BY_DRIVER, GET_FUEL_REPORT_BY_DRIVER),
    ])
}
